import { createContext } from "react";

export const emptyTicket = {
  customerId: "",
  assetId: "",
  customerTicketNo: "",
  activityType: "",
  category: "",
  subCategory: "",
  vaultAccessRequired: "No",
  assignmentGroup: "",
  assigneeId: "",
  secondaryAssigneeId: "",
  creationChannel: "Web",
  reportedBy: "",
  auditedBy: "",
  isChargeable: "Yes",
  isCustomerComplaint: "No",
  billingCharges: "Yes",
  correlationId: "",
  priority: "Normal",
  remarks: "",
  locationName: "",
  region: "",
};

export const SERVICE_TYPES = {};
export const CREATION_CHANNELS = [
  { id: "Customer Portal", text: "Customer Portal" },
  { id: "Web", text: "Web" },
  { id: "Auto Email", text: "Auto Email" },
];
export const TOGGLE = [
  { id: "Yes", text: "Yes" },
  { id: "No", text: "No" },
];
export const PRIORITIES_LIST = [
  { id: "Critical", text: "1-Critical", value: 1 },
  { id: "High", text: "2-High", value: 2 },
  { id: "Normal", text: "3-Normal", value: 3 },
  { id: "Low", text: "4-Low", value: 4 },
  { id: "Top", text: "5-Top", value: 10 },
  { id: "Cosmetic", text: "6-Cosmetic", value: 9 },
];
export const LEAD_NOTES = [
  { id: "Social Media", text: "Social Media", value: "Social Media" },
  { id: "Careers", text: "Careers", value: "Careers" },
  { id: "Word of Mouth", text: "Word of Mouth", value: "Word of Mouth" },
  {
    id: "Emirates Group Website",
    text: "Emirates Group Website",
    value: "Emirates Group Website",
  },
  {
    id: "Recommended by Someone",
    text: "Recommended by Someone",
    value: "Recommended by Someone",
  },
];
export const REGION_LIST = [
  { id: "Dubai", text: "Dubai", value: "Dubai" },
  { id: "Abu Dhabi", text: "Abu Dhabi", value: "Abu Dhabi" },
  { id: "Al Ain", text: "Al Ain", value: "Al Ain" },
  { id: "Northern Region", text: "Northern Region", value: "Northern Region" },
];
export const StatusContext = createContext({
  status: "",
  setStatus: () => {},
});
export const SERVICE_TYPES_PRIORITY = [
  { id: "Normal", text: "Normal", value: 3 },
  { id: "Routine", text: "Routine ", value: 5 },
  { id: "Fixed", text: "Fixed", value: 6 },
  { id: "SpecialService ", text: "Special Service  ", value: 7 },
  { id: "Adhoc", text: "Adhoc", value: 8 },
];
export const SERVICE_NATURE = [
  { id: "Replenishment", text: "Replenishment" },
  { id: "Clearance", text: "Clearance" },
];
export const SERVICE_STATUS = [
  { id: "Missed", text: "Missed" },
  { id: "Delayed", text: "Delayed" },
];
export const IMS_TYPE = [
  { id: "Standard", text: "Standard" },
  { id: "Emergency", text: "Emergency" },
];
export const INCIDENT_CATEGORIES = [
  { id: "Accident", text: "Accident" },
  { id: "Behavioral Safety", text: "Behavioral Safety" },
  { id: "First Aid", text: "First Aid" },
  { id: "Illness", text: "Illness" },
  { id: "Major (3+ days)", text: "Major (3+ days)" },
  { id: "Medical Related", text: "Medical Related" },
  { id: "Minor (<3 days)", text: "Minor (<3 days)" },
  { id: "Property Damages", text: "Property Damages" },
  { id: "Road Traffic", text: "Road Traffic" },
];
export const INCIDENT_TYPES = [
  { id: "Adverse Weather", text: "Adverse Weather" },
  { id: "Collision", text: "Collision" },
  { id: "Electrical Safety", text: "Electrical Safety" },
  { id: "Entanglement or Crush Injury", text: "Entanglement or Crush Injury" },
  {
    id: "Environmental Spillage (Oil or Chemical)",
    text: "Environmental Spillage (Oil or Chemical)",
  },
  { id: "Falling Object", text: "Falling Object" },
  { id: "Fire Incident", text: "Fire Incident" },
  { id: "Health Issue", text: "Health Issue" },
  { id: "Heavy Noise", text: "Heavy Noise" },
  { id: "Major Accident", text: "Major Accident" },
  {
    id: "Minor AccidentPoor Access - Egress",
    text: "Minor AccidentPoor Access - Egress",
  },
  { id: "Poor Visibility", text: "Poor Visibility" },
  { id: "Property Damage", text: "Property Damage" },
  { id: "Protruding - Flying Objects", text: "Protruding - Flying Objects" },
  { id: "Slip or Trip or Fall", text: "Slip or Trip or Fall" },
];
